"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoPane = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const InfoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/InfoIcon"));
const react_1 = __importDefault(require("react"));
require("react-quill/dist/quill.snow.css");
const InfoBox_1 = __importDefault(require("./InfoBox"));
const InnerPane_1 = __importDefault(require("./InnerPane"));
const InfoPane = ({ onClickClose }) => {
    return (react_1.default.createElement(InnerPane_1.default, { label: lib_i18n_1.default.t('show-info'), icon: react_1.default.createElement(InfoIcon_1.default, { size: 18 }), onClickClose: onClickClose },
        react_1.default.createElement(InfoBox_1.default, { style: { maxHeight: 300, marginTop: 8 } })));
};
exports.InfoPane = InfoPane;
exports.default = exports.InfoPane;
